import { ApiEndPoints, HttpMethods } from "../base/Settings";
import type { FetchRequest } from "../base/ui_general/GeneralInterfaces";

/**
 * Creates a FetchRequest object for fetching waterfall item concepts from the backend.
 */
export function getRequest_get_waterfall_item_concepts(): FetchRequest {
    return {
        api_endpoint: ApiEndPoints.WATERFALL_ITEM_CONCEPTS,
        method: HttpMethods.GET,
        query_parameters: {},
    };
}
